import type { DialogueLogType } from '@shared/types/dialogue-log';
import { deriveDialogueLogTitle } from './title';

/// 追加/編集モーダルのフォーム入力値。 `occurredAtInput` は `datetime-local`
/// input の生値 (local time)。
export interface DialogueLogFormState {
  occurredAtInput: string;
  type: DialogueLogType;
  title: string;
  body: string;
  /// 空文字 = 関連商談なし (`null` で送る)。
  relatedOpportunityId: string;
  participantLawyerIds: string[];
}

/// 作成/編集で共通の送信フィールド。 編集 (PATCH) ではこれがそのまま payload に
/// なる (`firm_id` / `created_at` / `updated_at` は含めない)。 作成では
/// `firm_id` を足して `DialogueLogCreateRequest` にする。
export interface DialogueLogFormPayload {
  type: DialogueLogType;
  occurred_at: string;
  title: string;
  body: string | null;
  related_opportunity_id: string | null;
  participant_lawyer_ids: string[];
}

/// フォーム入力から送信フィールドを組み立てる。
/// - title 未入力は `deriveDialogueLogTitle` で自動生成する。
/// - body は trim し、 空なら `null`。
/// - related_opportunity_id は空なら `null`。
/// - 日時が解釈できない場合は `occurred_at` を空のまま返し、 validation 側で
///   「日時を指定してください」 を出す (throw しない)。
export function buildDialogueLogFields(
  form: DialogueLogFormState,
): DialogueLogFormPayload {
  const occurredDate = new Date(form.occurredAtInput);
  const trimmedBody = form.body.trim();
  return {
    type: form.type,
    occurred_at: Number.isNaN(occurredDate.getTime()) ? '' : occurredDate.toISOString(),
    title: deriveDialogueLogTitle(form.title, form.body, form.type),
    body: trimmedBody.length === 0 ? null : trimmedBody,
    related_opportunity_id:
      form.relatedOpportunityId === '' ? null : form.relatedOpportunityId,
    participant_lawyer_ids: form.participantLawyerIds,
  };
}
